import React from "react";
import ReusableModal from "../../../components/common/ReusableModal";
import FormButton from "../../../components/form/FormButton";

const value = (v) => (v === null || v === undefined || v === "" ? "—" : v);

const formatDateTime = (v) => {
  if (!v) return "—";

  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return "—";

  return d.toLocaleString();
};

const LocalGameDetailModal = ({ open, item, loading = false, onClose }) => {
  return (
    <ReusableModal
      open={open}
      title="Local Game Details"
      onClose={onClose}
      width="920px"
      closeOnBackdrop={false}
      className="local-game-detail-modal"
    >
      {loading ? (
        <div className="sa-placeholder" style={{ height: 160 }}>
          Loading details…
        </div>
      ) : !item ? (
        <div className="sa-empty">No detail found.</div>
      ) : (
        <div className="lg-detail">
          <section className="lg-detail-section">
            <div className="lg-detail-title">Game Summary</div>

            <div className="lg-detail-grid">
              <div>
                <span>Game Code</span>
                <strong>{value(item.gameCode)}</strong>
              </div>

              <div>
                <span>Status</span>
                <strong>{value(item.status)}</strong>
              </div>

              <div>
                <span>Sport</span>
                <strong>{value(item.sportName)}</strong>
              </div>

              <div>
                <span>Venue Type</span>
                <strong>{value(item.venueType)}</strong>
              </div>

              <div>
                <span>Date</span>
                <strong>{value(item.date)}</strong>
              </div>

              <div>
                <span>Time</span>
                <strong>
                  {value(item.startTime)} - {value(item.endTime)}
                </strong>
              </div>

              <div>
                <span>Start At</span>
                <strong>{formatDateTime(item.startAt)}</strong>
              </div>

              <div>
                <span>End At</span>
                <strong>{formatDateTime(item.endAt)}</strong>
              </div>
            </div>
          </section>

          <section className="lg-detail-section">
            <div className="lg-detail-title">Creator</div>

            <div className="lg-detail-grid">
              <div>
                <span>Name</span>
                <strong>{value(item.creator?.fullName)}</strong>
              </div>

              <div>
                <span>Phone</span>
                <strong>{value(item.creator?.phoneE164)}</strong>
              </div>

              <div>
                <span>Email</span>
                <strong>{value(item.creator?.email)}</strong>
              </div>

              <div>
                <span>Creator Players</span>
                <strong>{value(item.creatorPlayersCount)}</strong>
              </div>
            </div>
          </section>

          <section className="lg-detail-section">
            <div className="lg-detail-title">Venue</div>

            <div className="lg-detail-grid">
              <div>
                <span>Venue Name</span>
                <strong>{value(item.venueName)}</strong>
              </div>

              <div>
                <span>Address</span>
                <strong>{value(item.address)}</strong>
              </div>

              <div>
                <span>Custom Venue</span>
                <strong>{item.venueType === "CUSTOM" ? "Yes" : "No"}</strong>
              </div>

              <div>
                <span>Timezone</span>
                <strong>{value(item.timezone)}</strong>
              </div>
            </div>
          </section>

          <section className="lg-detail-section">
            <div className="lg-detail-title">Players & Pricing</div>

            <div className="lg-detail-grid">
              <div>
                <span>Total Players</span>
                <strong>{value(item.totalPlayers)}</strong>
              </div>

              <div>
                <span>Joined Players</span>
                <strong>{value(item.joinedPlayers)}</strong>
              </div>

              <div>
                <span>Remaining Players</span>
                <strong>{value(item.remainingPlayers)}</strong>
              </div>

              <div>
                <span>Participants Count</span>
                <strong>{value(item.participantsCount)}</strong>
              </div>

              <div>
                <span>Price / Player</span>
                <strong>
                  {value(item.currency)} {value(item.pricePerPlayer)}
                </strong>
              </div>

              <div>
                <span>Skill / Type</span>
                <strong>
                  {value(item.skillLevel)} / {value(item.matchType)}
                </strong>
              </div>
            </div>
          </section>

          <section className="lg-detail-section">
            <div className="lg-detail-title">Participants</div>

            {Array.isArray(item.participants) && item.participants.length > 0 ? (
              <div className="lg-participants-list">
                {item.participants.map((p, index) => (
                  <div className="lg-participant-card" key={`${p.user?._id || index}`}>
                    <strong>{p.user?.fullName || "—"}</strong>
                    <span>{p.role || "player"}</span>
                    <small>
                      Players: {p.playersCount || 1}
                      {p.joinedAt ? ` • Joined: ${formatDateTime(p.joinedAt)}` : ""}
                    </small>
                    <small>{p.user?.phoneE164 || p.user?.email || "—"}</small>
                  </div>
                ))}
              </div>
            ) : (
              <div className="sa-empty">No participants found.</div>
            )}
          </section>

          <section className="lg-detail-section">
            <div className="lg-detail-title">Chat</div>

            <div className="lg-detail-grid">
              <div>
                <span>Chat Enabled</span>
                <strong>{item.chat?.chatEnabled ? "Yes" : "No"}</strong>
              </div>

              <div>
                <span>Read Only</span>
                <strong>{item.chat?.readOnly ? "Yes" : "No"}</strong>
              </div>

              <div className="lg-detail-span-2">
                <span>Firestore Room</span>
                <strong>{value(item.chat?.firestoreRoomPath)}</strong>
              </div>

              <div className="lg-detail-span-2">
                <span>Messages Path</span>
                <strong>{value(item.chat?.messagesPath)}</strong>
              </div>
            </div>
          </section>

          {item.cancellationReason && (
            <section className="lg-detail-section danger">
              <div className="lg-detail-title">Cancellation</div>

              <div className="lg-detail-grid">
                <div className="lg-detail-span-2">
                  <span>Reason</span>
                  <strong>{value(item.cancellationReason)}</strong>
                </div>

                <div>
                  <span>Cancelled At</span>
                  <strong>{formatDateTime(item.cancelledAt)}</strong>
                </div>

                <div>
                  <span>Cancelled By</span>
                  <strong>{value(item.cancelledBy?.fullName || item.cancelledBy)}</strong>
                </div>
              </div>
            </section>
          )}

          <section className="lg-detail-section">
            <div className="lg-detail-title">Notes</div>
            <p className="lg-notes">{value(item.notes)}</p>
          </section>

          <div className="lg-detail-actions">
            <FormButton type="button" variant="secondary" onClick={onClose}>
              Close
            </FormButton>
          </div>
        </div>
      )}
    </ReusableModal>
  );
};

export default LocalGameDetailModal;